import * as React from 'react';
import { PagerInterface } from '../../Helpers/PaginationHelper';
import { PageBrowserConfiguration } from './PageBrowserConfiguration';
import { PageBrowserLabels } from './PageBrowserLabels';
import { PaginationConfiguration } from './PaginationConfiguration';
import { PaginationKeyInterface } from './PaginationKeyInterface';

export interface PaginationContextProps<T> extends PaginationConfiguration, PageBrowserConfiguration {
    itemsOnPage: T[],
    pager: PagerInterface,
    onSelectPage: (pageNumber: number) => void;
}

export class PaginationContext<T extends PaginationKeyInterface> implements PaginationContextProps<T> {
    public readonly itemsOnPage: T[];

    public readonly initialPage: number | undefined;

    public readonly labels: Partial<PageBrowserLabels> | undefined;

    public readonly maxPages: number | undefined;

    public readonly pageSize: number | undefined;

    public readonly pager: PagerInterface;

    public readonly onSelectPage: (pageNumber: number) => void;

    constructor(
        itemsOnPage: T[],
        pager: PagerInterface,
        onSelectPage: (pageNumber: number) => void,
        initialPage: number | undefined,
        labels: Partial<PageBrowserLabels> | undefined,
        maxPages: number | undefined,
        pageSize: number | undefined,
    ) {
        this.itemsOnPage = itemsOnPage;
        this.initialPage = initialPage;
        this.labels = labels;
        this.maxPages = maxPages;
        this.pageSize = pageSize;
        this.pager = pager;
        this.onSelectPage = onSelectPage;
    }

    public showPage(pageNumber: number) {
        console.debug('[PaginationContext] Change page number ' + pageNumber, this);
        if (this.onSelectPage) {
            this.onSelectPage.call(this, pageNumber);
        }
    }
}

export const PaginationContextType = React.createContext((null as any) as PaginationContext<any>);
